import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import format from 'date-fns/format';
import { compareAsc } from 'date-fns';
import { Row, Col, Card, Tabs, Button, Modal, Select, Tag } from 'antd';
import Responsive from './Responsive';
import { useLocation, useNavigate } from 'react-router-dom';
import { timeSlotRequest, updateScheduleSlotRequest } from './Actions';
import { selectLoading, selectTimeSlotData, selectUpdatedScheduleData } from './Selectors';
import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import CustomSpin from '../CommonSpin';
import { BodyTextKey, CardHeading, TextDays } from '../CommonText';
import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
// import Responsive from './Responsive';
import throttle from 'lodash.throttle';


const TabPane = Tabs.TabPane;

const SelectTimeSlot = () => {
    const dispatch = useDispatch();
    const { state } = useLocation();
    const selectedPatientName = Number(state.payload.patientId);

    const updatedScheduleData = useSelector(selectUpdatedScheduleData);
    const requesting = useSelector(selectLoading);

    const navigate = useNavigate();

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    const applyViewportChange = 250;
    const [viewportWidth, setViewportWidth] = useState(0);
    // Function to handle viewport dimension changes
    const saveViewportDimensions = useCallback(
        throttle(() => {
            setViewportWidth(window.innerWidth);
        }, applyViewportChange),
        [applyViewportChange]
    );
    
    // useEffect to handle component mount and unmount for event listeners
    useEffect(() => {
        saveViewportDimensions(); // Initial call to set viewport width
        window.addEventListener('resize', saveViewportDimensions);
    
        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', saveViewportDimensions);
        };
    }, [saveViewportDimensions]);
        
    if(updatedScheduleData) {
        const payload = {
            consultType : state.payload.consultType ,
            doctorID : state.payload.doctorID ,
            endDate : state.payload.endDate ,
            orgId : state.payload.orgId ,
            patientId : state.payload.patientId ,
            selectedResidence : state.payload.selectedResidence ,
            startDate : state.payload.startDate,
            updatedScheduleData : updatedScheduleData

        };
        navigate(('/selectloc'),{state : { payload }});
    }
    
    const { familyGet, familyDetails, getOrgFees, orgFees } = useAuth();


    const timeSlots = useSelector(selectTimeSlotData);
    const startDate = [];
    // const requesting = false;
    // const orgFees = [];

    useEffect(() => {
        const payload = {
            orgid: state.payload.orgId,
            startDate: state.payload.startDate,
            endDate: state.payload.endDate,
            patientId: state.payload.patientId,
            doctorID: state.payload.doctorID,
        };
        dispatch(timeSlotRequest(payload));
    }, [dispatch]);

    useEffect(() => {
        familyGet();
        getOrgFees(state.payload.doctorID, null);
    }, []);


    const checkToken = (value) => {
        const consultationIn = state.payload.selectedResidence;
        let consultationTypeId;
        let orgFeesId;
        const consultationType = state.payload.consultType;

        orgFees.data.map((item) => {
            if (consultationType === 'walk') {
                if (item.feetype && item.feetype.feetype === 'HospitalInternational' && consultationIn === 'INTERNATIONAL') {
                    consultationTypeId = item.feeTypeId;
                    orgFeesId = item.id;
                } else if (item.feetype && item.feetype.feetype === 'HospitalNRI' && consultationIn === 'NRI') {
                    consultationTypeId = item.feeTypeId;
                    orgFeesId = item.id;
                } else if (item.feetype && item.feetype.feetype === 'Hospital' && consultationIn === 'DOMESTIC') {
                    consultationTypeId = item.feeTypeId;
                    orgFeesId = item.id;
                }
            } else if (item.feetype && item.feetype.feetype === 'videoInternational' && consultationIn === 'INTERNATIONAL') {
                consultationTypeId = item.feeTypeId;
                orgFeesId = item.id;
            } else if (item.feetype && item.feetype.feetype === 'videoNRI' && consultationIn === 'NRI') {
                consultationTypeId = item.feeTypeId;
                orgFeesId = item.id;
            } else if (item.feetype && item.feetype.feetype === 'Video' && consultationIn === 'DOMESTIC') {
                consultationTypeId = item.feeTypeId;
                orgFeesId = item.id;
            }
        });


        if (patientName !== null) {

            const payload = {
                consultationTypeId : consultationTypeId,
                orgFeesId : orgFeesId,
                slotId: value.id
            };

            dispatch(updateScheduleSlotRequest(payload));

        } else {
            Modal.warning({
                title: 'Please select values',
            });
        }
    };


    const patientName = [];
    if (familyDetails) {
        familyDetails && familyDetails.map((item) => {
            patientName.push({
                value: item.id,
                label: `${item.firstName} ${item.lastName}`
            });
        });
    }

    // const flag = localStorage.getItem('FLAG_UHID');
    let haveTimeSlots;
    const slots = [moment(startDate.value)];
    let date = startDate.value;

    // Generate schedule for next 7 days
    for (let i = 1; i < 7; i++) {
        date = moment(date).add(1, 'days');
        slots.push(date);
    }

    const tabBody = slots && slots.map((item) => {
        haveTimeSlots = false;
        let morning = false;
        let afterNoon = false;
        let evening = false;

        // const fultime = moment().format('HH:mm:ss');
        // const fdate = moment().format('yyyy-MM-dd');
        const utcDateTime = new Date().toISOString();
        const momentUTCTime = moment.utc(utcDateTime);
        const fultime = momentUTCTime.add(5, 'hours').add(30, 'minutes').format('HH:mm:ss');
        const fdate = momentUTCTime.format('YYYY-MM-DD');

        const morningBody = timeSlots && timeSlots.data.map((value) => {
            const temptime = `${value.date},${value.time} GMT+0530 (India Standard Time)`;
            const istTime = new Date(temptime);
            const utcDate = new Date(istTime).toISOString();
            const utcMoment = moment.utc(utcDate);        
            const istMoment = moment(utcMoment).add(5, 'hours').add(30, 'minutes');
            const timeOnly = istMoment.format('HH:mm:ss');
            const timeDisplay = istMoment.format('hh:mm A');    
            const timeDate = istMoment.format('YYYY-MM-DD');     

            if (timeDate === format(item, 'yyyy-MM-dd')) {
                if (compareAsc(`${timeDate} ${timeOnly}`, `${format(item, 'yyyy-MM-dd')} 00:00:00`) === 1 &&
                    compareAsc(`${timeDate} ${timeOnly}`, `${format(item, 'yyyy-MM-dd')} 12:00:00`) === -1) {
                    morning = true;
                    return (
                        <span key={value.id}>
                            {value.isVacant && (timeOnly > fultime || timeDate > fdate) ? (
                                <Button type="primary" ghost style={{ margin: 3 }} onClick={() => checkToken(value)}>
                                    {timeDisplay}
                                </Button>
                            ) : (
                                <Button disabled style={{ margin: 3 }} onClick={() => checkToken(value)}>
                                    {timeDisplay}
                                </Button>
                            )}
                        </span>
                    );
                }
            }
            return null;
        });

        const afterNoonBody = timeSlots && timeSlots.data.map((value) => {
            const temptime = `${value.date},${value.time} GMT+0530 (India Standard Time)`;
            const istTime = new Date(temptime);
            const utcDate = new Date(istTime).toISOString();    
            const utcMoment = moment.utc(utcDate);
            const istMoment = utcMoment.add(5, 'hours').add(30, 'minutes');
            const timeOnly = istMoment.format('HH:mm:ss');
            const timeDisplay = istMoment.format('hh:mm A');
            const timeDate = istMoment.format('YYYY-MM-DD');

            if (timeDate === format(item, 'yyyy-MM-dd')) {
                if (compareAsc(`${timeDate} ${timeOnly}`, `${format(item, 'yyyy-MM-dd')} 12:00:00`) === 1 &&
                    compareAsc(`${timeDate} ${timeOnly}`, `${format(item, 'yyyy-MM-dd')} 16:00:00`) === -1) {
                    afterNoon = true;
                    return (
                        <span key={value.id}>
                            {value.isVacant && (timeOnly > fultime || timeDate > fdate) ? (
                                <Button type="primary" ghost style={{ margin: 3 }} onClick={() => checkToken(value)}>
                                    {timeDisplay}
                                </Button>
                            ) : (
                                <Button disabled style={{ margin: 3 }} onClick={() => checkToken(value)}>
                                    {timeDisplay}
                                </Button>
                            )}
                        </span>
                    );
                }
            }
            return null;
        });

        const eveningBody = timeSlots && timeSlots.data.map((value) => {
            const temptime = `${value.date},${value.time} GMT+0530 (India Standard Time)`;
            const istTime = new Date(temptime);
            const utcDate = new Date(istTime).toISOString();
            const utcMoment = moment.utc(utcDate);
            const istMoment = utcMoment.add(5, 'hours').add(30, 'minutes');
            const timeOnly = istMoment.format('HH:mm:ss');
            const timeDisplay = istMoment.format('hh:mm A');
            const timeDate = istMoment.format('YYYY-MM-DD');

            if (timeDate === format(item, 'yyyy-MM-dd')) {
                if (compareAsc(`${timeDate} ${timeOnly}`, `${format(item, 'yyyy-MM-dd')} 16:00:00`) === 1 &&
                    compareAsc(`${timeDate} ${timeOnly}`, `${format(item, 'yyyy-MM-dd')} 23:59:59`) === -1) {
                    evening = true;
                    return (
                        <span key={value.id}>
                            {value.isVacant && (timeOnly > fultime || timeDate > fdate) ? (
                                <Button type="primary" ghost style={{ margin: 3 }} onClick={() => checkToken(value)}>
                                    {timeDisplay}
                                </Button>
                            ) : (
                                <Button disabled style={{ margin: 3 }} onClick={() => checkToken(value)}>
                                    {timeDisplay}
                                </Button>
                            )}
                        </span>
                    );
                }
            }
            return null;
        });        

        return (
            <TabPane tab={item.format('ddd MMM Do')} key={format(item, 'yyyy-MM-dd')}>
                {timeSlots && !timeSlots.data.some(slot => slot.date === format(item, 'yyyy-MM-dd')) && haveTimeSlots === false ? (
                    <div style={{ padding: '12%', textAlign: 'center' }}>
                        <CardHeading text = { `SLOTS AVAILABLE ON ${format(timeSlots && timeSlots.data && timeSlots.data[0].date, 'dd-MM-yyyy')} `} />
                    </div>
                ) : (
                    <div>
                        {morning && (
                            <div>
                                <h2>
                                    <i style={{ margin: 10, color: '#fff566' }} className="fas fa-sun" />
                                    <TextDays text = {langdata.Morning ? langdata.Morning : 'Morning' } />
                                </h2>
                                <div style={{ margin: 10 }}>{morningBody}</div>
                            </div>
                        )}
                        {afterNoon && (
                            <div>
                                <h2>
                                    <i style={{ margin: 10, color: '#faad14' }} className="far fa-sun" />
                                    <TextDays text = {langdata.AfterNoon ? langdata.AfterNoon : 'AfterNoon'} />
                                </h2>
                                <div style={{ margin: 10 }}>{afterNoonBody}</div>
                            </div>
                        )}
                        {evening && (
                            <div>
                                <h2>
                                    <i style={{ margin: 10, color: '#fff566' }} className="fas fa-moon" />
                                    <TextDays text = {langdata.Evening ? langdata.Evening : 'Evening' } />
                                </h2>
                                <div style={{ margin: 10 }}>{eveningBody}</div>
                            </div>
                        )}
                    </div>
                )}
            </TabPane>
        );
    });

    return (
        <Content>
            <div style={{ padding: 24 }}>
                <Responsive />
                <Row type="flex" justify="center" style={{ marginBottom: '20px' }}>
                    <Col xs={24} sm={24} lg={18} md={22}>
                        <Card>
                            <Row>
                                <Col span={4} style={{
                                    marginTop: '3px',
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                }}>
                                    <strong>
                                        <BodyTextKey text =  {langdata.PatientnameC ? langdata.PatientnameC : 'Patient name :' }/> &nbsp;</strong>
                                </Col>
                                <Col span={5}>
                                    <Select
                                        showSearch
                                        style={{ width: '100%' }}
                                        value={selectedPatientName}
                                        options={patientName}
                                        disabled
                                    >
                                    </Select>
                                </Col>
                                <Col span={1}>
                            &nbsp;
                                </Col>
                                <Col span={7} style={{
                                    marginTop: '3px',
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                }}>
                                    <strong>
                                        <BodyTextKey text =  {langdata.TypeofResidenceC ? langdata.TypeofResidenceC : 'Type of Residence :'} />&nbsp;</strong>
                                </Col>
                                <Col span={5}
                                    style={{
                                        marginTop: '3px',
                                    }}>
                                    {state.payload.selectedResidence}
                                </Col>
                            </Row>
                            {/* <Row style={{display: 'flex',
                                justifyContent: 'center'}}> */}
                            <Col 
                                span={24} 
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: '15px',
                                }}>
                                {/* <div style={{ marginTop: '15px' }}> */}
                                <Tag color="red">{
                                    <span style={{fontSize: viewportWidth < 560 ? '9px': ''}}>{langdata.AllTimeSlotsAreinIndianStandardTimeISTOnly ? langdata.AllTimeSlotsAreinIndianStandardTimeISTOnly : 'All Time Slots Are in Indian Standard Time(IST) Only. Please select the slot accordingly' }</span>
                                }
                                </Tag>
                                {/* </div> */}
                            </Col>
                            {/* </Row> */}
                        </Card>
                        <Row type="flex" justify="center">
                            <Col xs={24} lg={24} md={24}>
                                <Card>
                                    <Tabs defaultActiveKey="1" tabPosition="top">
                                        {tabBody}
                                    </Tabs>
                                </Card>
                                <Card style={{ marginTop: '10px', height: '50px' }}
                                    onClick={() => navigate(('/newtimeslot'),{state})}
                                >
                                    <div style={{ textAlign: 'center', marginTop: '-10px', color : '#1677ff', cursor : 'pointer' }}>
                                        {/* <Link to="/newtimeslot"> */}
                                        {langdata.RequestAppointment ? langdata.RequestAppointment : 'Request Appointment' }
                                        {/* </Link> */}
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <CustomSpin spinning = {requesting} />            
        </Content>
    );
};


export default SelectTimeSlot;
